// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"d5fa7f23","505":"f243bc56","508":"65d49778","533":"5c9181ed","546":"a7f14077","899":"3f588d6a"}[chunkId] + ".chunk.js";
};